export const MajorAnimationTypes = [
    'snowflake',
    'fly-x',
    'fly-x-reverse',
    'dvd',
    'dvd-reverse',
];

export const MajorAnimationVariationTypes = [
    'type-0',
    'type-1',
    'type-2',
    'type-3',
    'type-4',
    'type-5',
    'type-6',
    'type-7',
    'type-8',
    'type-9',
];